import { Grid, MenuItem, Stack } from '@mui/material';
import React, { useEffect, useState } from 'react';

import { AutocompleteInput, SelectInput, YesNoInput } from './Inputs';
import FormattedMessages from '../../../../messages/admin/CustomerProfileMessages';

const InternalTCR = ({ profile, enums, highlighted, onChange }) => {
  const [internal, setInternal] = useState({});
  const [dca, setDca] = useState([]);

  useEffect(() => {
    setInternal(profile?.internal || {});
  }, [profile]);

  useEffect(() => {
    if (enums?.cnp) {
      setDca(
        Object.entries(enums.cnp)
          .map(([id, label]) => {
            return { id, label: label.trim() };
          })
          .sort((a, b) => a.label.localeCompare(b.label))
      );
    }
  }, [enums]);

  const handleInputChange = (name, value) => {
    const newValue = { ...internal };
    newValue[name].value = value;

    setInternal(newValue);
    onChange('internal', newValue);
  };

  return (
    <Grid container spacing={10} sx={{ width: '100%' }}>
      {/* Left Column */}
      <Grid sx={{ maxWidth: { md: 460 } }} size={{ xs: 12, lg: 6 }}>
        <Stack spacing={3}>
          {internal.csp?.visible && (
            <SelectInput
              id="csp"
              name="csp"
              label={FormattedMessages.csp}
              value={internal.csp?.value}
              required={internal.csp?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            >
              <MenuItem value="ro">Red Oxygen</MenuItem>
              <MenuItem value="completeSms">Complete SMS</MenuItem>
            </SelectInput>
          )}

          {internal.dca?.visible && (
            <AutocompleteInput
              id="dca"
              name="dca"
              options={dca}
              label={FormattedMessages.dca}
              value={internal.dca?.value}
              required={internal.dca?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}

          {internal.auto_renewal?.visible && (
            <YesNoInput
              id="auto_renewal"
              name="auto_renewal"
              label={FormattedMessages.autoRenewal}
              value={internal.auto_renewal?.value}
              required={internal.auto_renewal?.required}
              onChange={handleInputChange}
              highlighted={highlighted}
            />
          )}
        </Stack>
      </Grid>
    </Grid>
  );
};

export default InternalTCR;
